module.exports = __webpack_public_path__ + "assets/img/no.94a4132f.png";